// Shared helpers for the CompTIA certification catalog + per-certification
// detail pages (CompTIADetailPage.jsx and CompTIACertDetailPage.jsx).

// Parse comptiaOverviewSection: expects
// { intro, discover*, certs: [{name, body, badge_image, skills, careerPath, category, tag}] }
export function parseOverviewJson(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && Array.isArray(parsed.certs)) return parsed;
  } catch {}
  return null; // plain text — caller falls back to rendering it as-is
}

export function slugifyCert(name) {
  return (name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

// Scrolls to an element, accounting for the sticky navbar height.
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const navbar = document.querySelector("header.sticky");
  const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 100;
  const top = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight - 16;
  window.scrollTo({ top, behavior: "smooth" });
}

export const CERT_CATEGORIES = [
  { key: "ai", label: "AI" },
  { key: "cyber", label: "Cyber" },
  { key: "data", label: "Data" },
  { key: "digital-skills", label: "Digital Skills" },
  { key: "tech-support", label: "Tech Support" },
];

export const DISCOVER_TABS = [
  { key: "overview", label: "Overview" },
  { key: "all", label: "All" },
  ...CERT_CATEGORIES,
];

// Fallback category/tag for certs entered before the CMS "category"/"tag"
// fields existed. CMS values always win — this only fills the gap.
const KNOWN_CERT_META = {
  "comptia it fundamentals": { tag: "IT Fundamentals", category: "digital-skills" },
  "comptia a+": { tag: "Help Desk Support Specialist", category: "tech-support" },
  "comptia network+": { tag: "Network Administrator", category: "network" },
  "comptia security+": { tag: "Security Analyst", category: "cyber" },
  "comptia cloud+": { tag: "Cloud Engineer", category: "cloud" },
  "comptia project+": { tag: "Project Coordinator", category: "digital-skills" },
};

export function inferCertMeta(cert) {
  const key = Object.keys(KNOWN_CERT_META).find((k) => cert.name?.toLowerCase().includes(k));
  const known = key ? KNOWN_CERT_META[key] : null;
  return {
    category: cert.category || known?.category || "tech-support",
    tag: cert.tag || known?.tag || "IT Professional",
  };
}

// Fallback copy shown until the CMS "Discover Our Certifications" text fields are filled in.
export const DEFAULT_DISCOVER_COPY = {
  heading: "Discover Our Certifications",
  subtitle:
    "Build the skills employers need. Explore JRIIT's CompTIA certification pathways by career area and find the one that matches your goals.",
  cardTitle: "Take your next step with certifications and skills-based training",
  cardBody:
    "From entry level to advanced, unlock new career opportunities with industry-leading CompTIA certifications in IT support, cybersecurity, networking, cloud, and data — delivered locally through JRIIT's authorised training partnership.\n\nWhether you're learning independently or as part of an organisation, we're here to support your goals every step of the way.",
  ctaLabel: "Browse all credentials",
  skillAreaHeading: "Explore by skill area",
};
